import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Row, Workbook as wb, Worksheet} from "exceljs";
import {HorasExtrasTurnosService} from "../../services/horas-extra-turnos.service";
import {ModificacionMarcionesService} from "../../services/modificacion-marcaciones.service";
import {VerificacionTalentoHumanoService} from "../../services/verificacion-talento-humano.service";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {forkJoin, Subscription} from "rxjs";
import {saveAs} from 'file-saver';
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {CheckboxRenderer} from "../../../../shared/components/lfsa-checkbox/lfsa-checkbox.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {DecimalPipe} from "@angular/common";
import * as _ from 'lodash';

@Component({
  selector: 'app-verificacion-talento-humano-recursos-humanos',
  templateUrl: './verificacion-talento-humano-recursos-humanos.component.html',
  styleUrls: ['./verificacion-talento-humano-recursos-humanos.component.css']
})
export class VerificacionTalentoHumanoRecursosHumanosComponent implements OnInit {


  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  cmbYears: any[] = [];
  cmbWeeks: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;

  mont = true;
  week = false;


  @ViewChild('fileInput') fileInput: ElementRef;


  cmbDepartment: any[] = [];
  cmbEmployees: any[] = [];
  subscription1$: Subscription;


  constructor(
    private fb: FormBuilder,
    private _horasExtrasTurnos: HorasExtrasTurnosService,
    private _modificacionMarcaciones: ModificacionMarcionesService,
    private _verificacionTalentoHumanoService: VerificacionTalentoHumanoService,
    private _util: UtilsService,
    private numberFormatter: DecimalPipe
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.horasExtrasVerificacionTalentoHumano;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.calculateCombos();
    this.calculateCombos2();
    this.formulario = this.fb.group({
      year: ['', [Validators.required]],
      week: ['', [Validators.required]],
      id: ['', []],
      startDate: ['', []],
      endDate: ['', []],
    });
    this.uploadForm = this.fb.group({
      excel: [''],
    });
    this.girdComponent();
    this.selectCurrentDate();
  }

  calculateCombos2() {
    this.loading = true;
    const _getAllEmployees = this._modificacionMarcaciones.getAllEmployees();
    const _getAllDepartment = this._modificacionMarcaciones.getAllDepartment();
    forkJoin([_getAllEmployees, _getAllDepartment]).subscribe((res: any) => {
      res[0].map(employe => {
        employe.id = employe.cedula;
        employe.descripcion = employe.cedula + ' | ' + employe.nombres;
      });
      res[1].map(department => {
        department.id = department.codigo;
      });
      this.cmbEmployees = res[0];
      this.cmbDepartment = res[1];
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbEmployees = [];
      this.cmbDepartment = [];
    });
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getMondayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? -6 : 1);
    const monday = new Date(day.setDate(first));
    return monday;
  }

  getSundayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? 0 : 7);
    const sunday = new Date(day.setDate(first));
    return sunday;
  }

  addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

  formatoFecha(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
  }

  calculateWeeks(year, today?) {
    this.cmbWeeks = [];
    let firtsDateOfActualYear = new Date('01/01/' + year);
    let lastDateOfActualYear = new Date('12/31/' + year);
    for (let weeks = 1; firtsDateOfActualYear <= lastDateOfActualYear; weeks++) {
      let monday = this.getMondayOfCurrentWeek(firtsDateOfActualYear);
      let sunday = this.getSundayOfCurrentWeek(firtsDateOfActualYear);
      const payload = {
        id: weeks,
        descripcion: 'Semana ' + (weeks < 10 ? '0' + weeks : weeks) + ':   ' + this.formatoFecha(monday) + ' - ' + this.formatoFecha(sunday),
      };
      if (today && this.validateDate(firtsDateOfActualYear, today)) {
        this.actualWeek = weeks;
      }
      this.cmbWeeks.push(payload);
      firtsDateOfActualYear = this.addDays(firtsDateOfActualYear, 7);
    }
  }

  changeYear() {
    if (this.formulario.get('year').value && this.week) {
      this.calculateWeeks(this.formulario.get('year').value);
    }
  }

  validateDate(firtDateF, secondDateF) {
    let firtDate = this.getMondayOfCurrentWeek(firtDateF);
    let secondDate = this.getMondayOfCurrentWeek(secondDateF);
    if ((firtDate.getDate() === secondDate.getDate()) && (firtDate.getFullYear() === secondDate.getFullYear()) && (firtDate.getMonth() === secondDate.getMonth())) {
      return true;
    } else {
      return false;
    }
  }

  calculateCombos() {
    const date = new Date();
    let year = date.getFullYear();
    if (this.week) {
      this.calculateWeeks(year, date);
    } else {
      this.cmbWeeks = [
        {
          id: 1,
          descripcion: 'Enero'
        },
        {
          id: 2,
          descripcion: 'Febrero'
        },
        {
          id: 3,
          descripcion: 'Marzo'
        },
        {
          id: 4,
          descripcion: 'Abril'
        },
        {
          id: 5,
          descripcion: 'Mayo'
        },
        {
          id: 6,
          descripcion: 'Junio'
        },
        {
          id: 7,
          descripcion: 'Julio'
        },
        {
          id: 8,
          descripcion: 'Agosto'
        },
        {
          id: 9,
          descripcion: 'Septiembre'
        },
        {
          id: 10,
          descripcion: 'Octubre'
        },
        {
          id: 11,
          descripcion: 'Noviembre'
        },
        {
          id: 12,
          descripcion: 'Diciembre'
        },
      ];
    }
    this.cmbYears = [
      {
        id: year - 1,
        descripcion: year - 1
      },
      {
        id: year,
        descripcion: year
      },
      {
        id: year + 1,
        descripcion: year + 1
      }
    ];
  }

  selectCurrentDate() {
    const date = new Date();
    let year = date.getFullYear();
    this.formulario.get('year').setValue(year);
    this.formulario.get('week').setValue(date.getMonth() + 1);
    this.listAll();
  }

  getAllHorasExtra() {
    this.loading = true;
    const payload = this.formulario.value;
    if (this.mont) {
      this.subscription1$ = this._verificacionTalentoHumanoService.getAllByMont(payload).subscribe((res: any) => {
        res.map(data => {
          data.status = data.id ? 'APROBADO' : 'SIN APROBAR';
          data.check = data.id ? true : false;
        });
        this.rowData = res;
        this.loading = false;
      }, () => {
        this.loading = false;
        this.rowData = [];
      });
    } else {
      this._verificacionTalentoHumanoService.getAllByWeek(payload).subscribe((res: any) => {
        res.map(data => {
          data.status = data.id ? 'APROBADO' : 'SIN APROBAR';
          data.check = data.id ? true : false;
        });
        this.rowData = res;
        this.loading = false;
      }, () => {
        this.loading = false;
        this.rowData = [];
      });
    }
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      checkboxRenderer: CheckboxRenderer
    };

    this.columnDefs = [
      {
        headerName: 'CEDULA',
        field: 'cedula',
        sortable: true,
        filter: true,
        width: 120
      },
      {
        headerName: 'NOMBRE',
        field: 'nombre',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'DEPARTAMENTO',
        field: 'departamento',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'FECHA',
        field: 'fecha',
        sortable: true,
        filter: true,
        width: 115
      },
      {
        headerName: 'RECARGO NOC',
        field: 'percent_25',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'SUPLEMENTARIAS',
        field: 'percent_50',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'EXTRAORDINARIAS',
        field: 'percent_100',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'TOTAL H-EXTRA',
        field: 'horasExtrasTrabajadas',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'TOTAL H',
        field: 'horasTrabajadas',
        sortable: true,
        filter: true,
        width: 150
      },
    ];
    this.columnDefs[4].valueFormatter = (data) => this.numberFormatter.transform(data.value, '1.2-2');
    this.columnDefs[4].type = 'numericColumn';
    this.columnDefs[5].valueFormatter = (data) => this.numberFormatter.transform(data.value, '1.2-2');
    this.columnDefs[5].type = 'numericColumn';
    this.columnDefs[6].valueFormatter = (data) => this.numberFormatter.transform(data.value, '1.2-2');
    this.columnDefs[6].type = 'numericColumn';
    this.columnDefs[7].valueFormatter = (data) => this.numberFormatter.transform(data.value, '1.2-2');
    this.columnDefs[7].type = 'numericColumn';
    this.columnDefs[8].valueFormatter = (data) => this.numberFormatter.transform(data.value, '1.2-2');
    this.columnDefs[8].type = 'numericColumn';
    this.rowSelection = 'single';
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  listAll() {
    if (this.formulario.valid) {
      this.subscription1$ && this.subscription1$.unsubscribe();
      this.getAllHorasExtra();
    }
  }

  descargarExcel() {
    this.generarEcxel();
  }

  descargarExcelGeneral() {
    this.generarEcxelGeneral();
  }


  async generarEcxel() {
    this.dataExcel = [];
    this.workbook = new wb();
    this.rowData.forEach(x => {
      let payload = {
        cedula: x.cedula,
        nombre: x.nombre,
        departamento: x.departamento,
        horasExtrasTrabajadas: x.horasExtrasTrabajadas,
        horasTrabajadas: x.horasTrabajadas,
        fecha: x.fecha,
        rangoNocturno: x.percent_25,
        suplementaria: x.percent_50,
        extraordinario: x.percent_100,
      };
      this.dataExcel.push(payload);
    });
    this.fillExcelMarketplace();
    await this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'reporte-detallado' + '.xlsx');
    });
  }

  getGeneralList(initList: any[]) {
    let newList: any[] = [];
    let copyList = _.cloneDeep(initList);
    copyList.forEach((data: any) => {
      let register = newList.find(element => element.cedula === data.cedula);
      if (register) {
        register.percent_25 = register.percent_25 + data.percent_25;
        register.percent_50 = register.percent_50 + data.percent_50;
        register.percent_100 = register.percent_100 + data.percent_100;
      } else {
        newList.push(data);
      }
    });
    return newList;
  }

  async generarEcxelGeneral() {
    this.dataExcel = [];
    this.workbook = new wb();
    let data = this.getGeneralList(this.rowData);
    data.forEach(x => {
      let payload = {
        cedula: x.cedula,
        nombre: x.nombre,
        departamento: x.departamento,
        centroCosto: x.centroCosto,
        rangoNocturno: x.percent_25,
        suplementaria: x.percent_50,
        extraordinario: x.percent_100,
        cargo: x.cargo,
        localidad: x.localidad,
      };
      this.dataExcel.push(payload);
    });
    this.fillExcelMarketplace2();
    await this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'reporte-general' + '.xlsx');
    });
  }

  fillExcelMarketplace() {
    const nameSheet = 'Talento Humano';
    let header;

    header = [
      'Cédula colaborador',
      'Colaborador',
      'Departamento',
      'Horas extra Trabajadas',
      'Horas Trabajadas',
      'Fecha',
      'Rango Nocturno',
      'Suplementaria',
      'Extraordinaria',
    ];
    let row;
    let headerRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left: 0.3149606,
          right: 0.3149606,
          top: 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    row = worksheet.getRow(0);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;

    worksheet.columns[0].width = 15;
    worksheet.columns[1].width = 40;
    worksheet.columns[2].width = 30;
    worksheet.columns[3].width = 30;
    worksheet.columns[4].width = 10;
    worksheet.columns[5].width = 10;
    worksheet.columns[6].width = 20;
    worksheet.columns[7].width = 20;
    worksheet.columns[8].width = 20;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      });
    });

    this.data = this.formatData();

    this.fillRows(worksheet);

    this.formatWorksheet(worksheet, headerRow);
  }

  fillExcelMarketplace2() {
    const nameSheet = 'Talento Humano';
    let header;

    header = [
      'Cédula colaborador',
      'Colaborador',
      'Departamento',
      'Centro Costo',
      'Rango Nocturno',
      'Suplementaria',
      'Extraordinaria',
      'Cargo',
      'Localidad',
    ];
    let row;
    let headerRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left: 0.3149606,
          right: 0.3149606,
          top: 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    row = worksheet.getRow(0);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;
    worksheet.columns[0].width = 15;
    worksheet.columns[1].width = 40;
    worksheet.columns[2].width = 30;
    worksheet.columns[3].width = 30;
    worksheet.columns[4].width = 10;
    worksheet.columns[5].width = 10;
    worksheet.columns[6].width = 20;
    worksheet.columns[7].width = 30;
    worksheet.columns[8].width = 30;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      });
    });

    this.data = this.formatData();

    this.fillRows(worksheet);

    this.formatWorksheet(worksheet, headerRow);
  }

  fillRows(worksheet: Worksheet) {
    for (const x1 of this.data) {
      const x2 = Object.keys(x1);
      const temp = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }
  }

  formatWorksheet(worksheet: Worksheet, headerRow: Row) {
    worksheet.eachRow(function (Rowt, rowNum) {
      Rowt.eachCell(function (cell, cellNum) {
        if (rowNum === headerRow.number) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '1aa798'},
            bgColor: {argb: 'FF0000FF'},
          };
          cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'},
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            bold: true,
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    });
  }

  formatData(n?: any) {
    this.data = [];
    switch (true) {
      default: {
        this.data = this.dataExcel;
        break;
      }
    }

    return this.data;
  }


  onFileSelect(event) {
    this.loading = true;
    let allowedExtensions = /(.xlsx)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.uploadForm.get('excel').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "xlsx" (EXCEL) ', true, 9000);
        this.fileInput.nativeElement.value = '';
        this.loading = false;
      } else {
        this.uploadForm.get('excel').setValue(file);
        const formData = new FormData();
        formData.append('file', this.uploadForm.get('excel').value);
        const payload = this.formulario.value;
        this._horasExtrasTurnos.loadShifts(payload, formData).subscribe(response => {
          this.listAll();
        });
      }
    }
  }

  cargarAprobacion() {
    this.loading = true;
    const payload = [];
    this.rowData.forEach(data => {
      /*      if(data.check && !data.id){
              payload.push(data);
            }*/
      if (data.check) {
        payload.push(data);
      }
    });
    this._verificacionTalentoHumanoService.procesarHorasExtras(payload).subscribe((res: any) => {
      this.loading = false;
      this.listAll();
    }, () => {
      this.loading = false;
      this.listAll();
    });
  }

  revision(event) {
    if (event === 'week') {
      this.week = true;
      this.mont = false;
    } else if (event === 'mont') {
      this.week = false;
      this.mont = true;
    }
    this.calculateCombos();
    this.formulario = this.fb.group({
      year: ['', [Validators.required]],
      week: ['', [Validators.required]],
      id: ['', []],
      startDate: ['', []],
      endDate: ['', []],
    });
    this.rowData = [];
  }

}
